import { FC, PropsWithChildren, useState } from "react";
import WizardRedirectContext from "./wizard-redirect-context";

const WizardRedirectProvider: FC<PropsWithChildren> = ({ children }) => {
  const [canRedirect, setCanRedirect] = useState(true);

  return (
    <WizardRedirectContext.Provider value={{ canRedirect, setCanRedirect }}>
      {children}
    </WizardRedirectContext.Provider>
  );
};

export default WizardRedirectProvider;
